import { eventBus, domEvents, withPlugins } from '@spon/plugins';

const MobileMenu = ({ node, plugins: { addEvents } }) => {
	const MOBILE_MENU_VISIBLE = 'mobile__menu-visible';

	const changeSelectedMenu = targetID => {
		const current = node.querySelector(`.${MOBILE_MENU_VISIBLE}`);

		const active = node.querySelector(`#${targetID}`);
		if (active) active.classList.add(MOBILE_MENU_VISIBLE);
	};

	const clickToOpen = ({ target }) => {
		const targetID = target.closest('button').dataset.target;
		changeSelectedMenu(targetID);
	};

	const hideSubmenu = ({ target }) => {
		const targetID = target.closest('button').dataset.target;
		const submenuToHide = node.querySelector(`#${targetID}`);
		if (submenuToHide) submenuToHide.classList.remove(MOBILE_MENU_VISIBLE);
	};

	const resetMenu = () => {
		const visibleItems = [...node.querySelectorAll('.mobile__menu-visible')];

		visibleItems.forEach(item => {
			// console.log(item.id);
			if (item.id !== 'mobile__menu-home') {
				item.classList.remove(MOBILE_MENU_VISIBLE);
			}
		});
	};

	eventBus.on('menu:close', resetMenu);

	addEvents({
		'click [data-submenu-link]': clickToOpen,
		'click [data-back-button]': hideSubmenu,
	});
};

export default withPlugins(domEvents)(MobileMenu);
